import gql from 'graphql-tag';

export default gql`
  mutation rsvpRepVisit($input: rsvpRepVisitInput!) {
    rsvpRepVisit(input: $input) {
      repVisit {
        id
        date
        appointments {
          id
          bookedByCollege
          bookedByUser
          status
          currentColleges
          userBookingStatus
        }
        status
        currentColleges
      }
    }
  }
`;
